import { THREEDS_CHANNEL_NAME, THREE_DS_STATUS } from "@checkout/constants";
import { TeaCommonParams } from "@checkout/models/pipo-next/tea";

export interface IThreedsLandData {
  bizId: string;
  bizName: "instrument_auth" | "cash_payin";
  returnUrl: string;
  errorPageUrl: string;
  paDetails: IAnyObject;
  merchant_id: string;
  merchant_user_id: string;
  language: string;
  country_or_region: string;
  pipoTransactionChannelData: IAnyObject;
  pipoUniq3dsId?: string;
}

export interface IRedirectData {
  body: IObject;
  header?: IObject;
  method: string;
  url: string; // 3ds页面
}

export interface ICookieData {
  biz_id: string;
  biz_name: "instrument_auth" | "cash_payin";
  return_url: string;
  merchant_id?: string;
  merchant_user_id?: string;
  country_or_region?: string;
  payment_reference?: string;
}

export enum CheckStatus {
  // 2022.03.31 update：新paycore的状态机枚举包括 INIT, PROCESSING, PENDING, FAILED, SUCCEED 五种
  init = "init",
  processing = "processing",
  succeed = "succeed",
  // 老paycore的状态机枚举
  success = "success",
  pending = "pending",
  failed = "failed",
  error = "error",
  // 超时
  timeout = "timeout",
  fail = "fail",
  // 超过轮询次数，为前端状态
  pollingExceed = "pollingExceed",
}

export enum TransactionStatus {
  success = "success",
  failed = "failed",
}

export interface IPagePstate {
  redirectData: IRedirectData;
  threedsLandData: IThreedsLandData;
  cookieData: ICookieData;
  isProd: boolean;
  newFlow?: boolean;
  channelName: keyof typeof THREEDS_CHANNEL_NAME;
  pmId: string;
  displayTexts: Omit<IDisplayText, "bind">;
  super3ds?: 0 | 1;
}
type TBaseDisplayText = {
  pageTitle: string;
  title: string;
  subTitle: string;
};
export interface IDisplayText {
  collecting: TBaseDisplayText;
  loading: TBaseDisplayText;
  retry: TBaseDisplayText & {
    btn: string;
  };
  error: TBaseDisplayText & {
    btn: string;
  };
  pollingRetry: TBaseDisplayText & {
    btn: string;
  };
  bind: Pick<IDisplayText, "loading" | "retry" | "pollingRetry" | "error">;
}

// TODO: auto typing
export interface ICommonPageDisplayText {
  ovo: TBaseDisplayText;
  gopay: TBaseDisplayText & {
    or: string;
    main: string;
    main1: string;
    main2: string;
    buttonOpenApp: string;
    buttonDownload: string;
    buttonPaymentFinished: string;
  };
  loading: TBaseDisplayText;
  retry: TBaseDisplayText & {
    btn: string;
  };
  error: TBaseDisplayText & {
    btn: string;
  };
  pollingRetry: TBaseDisplayText & {
    btn: string;
  };
  bind: Pick<
    ICommonPageDisplayText,
    "loading" | "retry" | "pollingRetry" | "error"
  >;
}

export interface ThreeDSTeaCommonParams extends TeaCommonParams {
  merchant_id: string;
  user_id: string;
  country_code: string;
  payment_reference: string;
  "3ds_type": string;
  "3ds_flow_type": string;
  one_page_standalone_3ds: string;
  "3ds_fe_status": THREE_DS_STATUS;
}
